import { Box, LinearProgress, Stack, styled, Typography } from '@mui/material';
import { ReactNode, useEffect, useMemo } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useLoading } from 'contexts/loading';
import { StorageServices } from 'services/storage';
import { ROLE, widthScreen } from 'const/common';
import { useNewMessage } from 'contexts/newMessage';

type SideMenu = {
  label: string;
  link: string;
  iconActive?: string;
  iconInactive?: string;
  hidden?: boolean;
  paths?: string[];
  items?: SideMenu[];
};

type LayoutProps = {
  children: ReactNode;
};

const storage = new StorageServices();

export const LayoutAdmin = ({ children }: LayoutProps) => {
  const role = storage.getRole();
  const navigate = useNavigate();
  const { loading: callbackLoading } = useLoading();
  const isMobile = widthScreen < 900;
  const { isNewMessage } = useNewMessage();
  const MENU: SideMenu[] = useMemo(() => {
    return [
      {
        label: 'File Overview',
        link: '/admin/file-overview'
      },
      {
        label: 'Performance Overview',
        link: '/admin/performance-overview'
      },
      {
        label: 'Communication',
        link: '/admin/communication'
      },
      {
        label: 'New File Set Up',
        link: '/admin/set-up-file'
      },
      {
        label: 'Dispatch',
        link: '/admin/dispatch'
      },

      {
        label: 'Redemptions',
        link: '/admin/redemptions'
      },
      {
        label: 'Archive',
        link: '/admin/archive'
      },
      {
        label: 'Maps',
        link: '/admin/map'
      },
      {
        label: 'Control Panel',
        link: '/admin/control-panel'
      }
    ];
  }, []);

  useEffect(() => {
    if (role === ROLE.USER) {
      navigate('/forbidden');
    }
  }, [role]);
  return (
    <Stack
      minHeight={'100dvh'}
      flexDirection={isMobile ? 'column' : 'row'}
      width={'100%'}
      position={'relative'}>
      {callbackLoading && <LinearLoading color="success" />}
      <WrapperNavbar>
        <img
          style={{ cursor: 'pointer' }}
          alt={'img'}
          width={143}
          src={'/images/logo.png'}
          onClick={() => navigate('/admin')}
        />
        <Wrapper>
          {MENU.map((item, index) => {
            if (item.hidden) return;
            return (
              <NavLink to={item.link} key={index}>
                <WrapperItem className={'button-navbar'} gap={'14px'}>
                  <Box sx={{ position: 'relative', display: 'inline-block' }}>
                    <TextStyled className={'text-menu'}>{item.label}</TextStyled>
                    {item.label === 'Communication' && isNewMessage && (
                      <Box
                        sx={{
                          position: 'absolute',
                          top: -4,
                          right: -10,
                          width: 10,
                          height: 10,
                          borderRadius: '50%',
                          backgroundColor: 'red'
                        }}
                      />
                    )}
                  </Box>
                </WrapperItem>
              </NavLink>
            );
          })}
        </Wrapper>
      </WrapperNavbar>
      <Stack flex={5} sx={{ background: '#F3F5FA' }} width={'100%'} alignItems={'center'}>
        {children}
      </Stack>
    </Stack>
  );
};

const Wrapper = styled(Stack)(() => ({
  width: '100%',
  marginTop: '20px',
  '.active': {
    '.button-navbar': {
      background: `#22374A !important`,
      '.text-menu': {
        color: '#fff'
      }
    }
  }
}));

const LinearLoading = styled(LinearProgress)(() => ({
  position: 'fixed',
  width: '100vw',
  zIndex: 1000
}));
const WrapperNavbar = styled(Stack)(() => ({
  flex: 1,
  padding: '40px 0',
  maxWidth: 240,
  background: '#F4F5F6',
  alignItems: 'center',
  borderRight: '1px solid #BABAB6'
}));
const WrapperItem = styled(Stack)(() => ({
  width: '100%',
  alignItems: 'flex-start',
  justifyContent: 'center',
  paddingLeft: '48px',
  height: '50px'
}));
const TextStyled = styled(Typography)(() => ({
  fontSize: '14px',
  fontWeight: '700',
  color: '#202224'
}));
